<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Annual Budget per Department 
                <div class="card-header-actions">
                    <b-button variant="primary mr-1" @click="add" v-if="enableNextYear">Create Budget {{nextYear}}</b-button>
                    <b-button variant="primary mr-1" @click="edit">Add/Edit</b-button>
                    <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> print</b-button>
                    <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
                    <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
                </div>
            </div>
            <b-row >
                <b-col lg="2">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Year Of</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tahun" type="number"  :state="!$v.filter.tahun.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Department</span></b-input-group-prepend>
                        <b-form-input readonly v-model="filter.departemen" :state="!$v.filter.departkd.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuDeptShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="3">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col lg="1">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Open</b-button>
                </b-col>

            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table >
                        <thead>
                            <tr>
                            <th width="400px">Description</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Jan {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Jan</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Feb {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Feb</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Mar {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Mar</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Apr {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Apr</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">May {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">May</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Jun {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Jun</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Jul {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Jul</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Aug {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Aug</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Sep {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Sep</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Oct {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Oct</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Nov {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Nov</th>
                            <th v-if="filter.tahun" style="text-align:right" width="110px">Dec {{filter.tahun}}</th>
                            <th v-if="!filter.tahun" style="text-align:right" width="110px">Dec</th>
                            <th style="text-align:right" width="110px">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.idrowunik">
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.jan | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.feb | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.mar | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.apr | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.mei | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.jun | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.jul | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.agt | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" style="text-align:right">{{row.sep | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.okt | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.nov | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.des | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.total | numFormat}}</td>
                            <td v-else ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuDeptShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDept"></lku-department>
        </b-modal>        
        <b-modal v-model="showAddConfirm" header-bg-variant="primary"  :title="`Create New Budget ${nextYear}`" :centered="true" @ok="createBudget">
            <b-form @submit.stop.prevent="createBudget">
                <b-input-group>
                    <b-input-group-prepend ><label>Copy From</label></b-input-group-prepend>
                    <b-form-radio-group  class="mt-2" v-model="model.copysrc" name="radioIndividu" :state="!$v.model.copysrc.$error">
                        <b-form-radio value="0">Previous Budget</b-form-radio>
                        <b-form-radio value="1">Previous Actual</b-form-radio>
                    </b-form-radio-group>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Year Of Previous</label></b-input-group-prepend>
                    <b-form-input v-model="model.tahunsrc" type="number"  :state="!$v.model.tahunsrc.$error"></b-form-input>
                    <b-input-group-append><span  style="width:100px !important">&nbsp;</span></b-input-group-append>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Percentage Mark UP</label></b-input-group-prepend>
                    <b-form-input v-model="model.markup" type="number"  :state="!$v.model.markup.$error"></b-form-input>
                    <b-input-group-append><span class="input-group-text" style="width:100px !important">%</span></b-input-group-append>
                </b-input-group>
            </b-form>
        </b-modal>

    </div>
</template>



<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuDepartment from "../lookup/lkuDepartment";
import budget_dept from "../../apis/budget_dept";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        departkd: { required },
        tahun: { required },
    },
    model: {
        copysrc: { required },
        tahunsrc: { required },
        markup: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY')},
      model: {copysrc:0,markup:0,tahunsrc:parseInt(this.$store.state.user.tglaktif.substring(0,4))},
      nextYear: parseInt(this.$store.state.user.tglaktif.substring(0,4))+1,
      enableNextYear: true,
      lkuDeptShow:false,
      isLoading: false,
      showAddConfirm:false,
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { lkuDepartment,Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
// watch:{
//       layout: async function(newval) {
//           this.rptLines= await budget_dept.layout({layout : newval});
//       }
//   },
created: async function (){
     this.layouts = await budget_dept.layout_combo();
     let bln = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').month();
    //  let awal= parseInt(this.$store.state.user.awalbln || '1')-1;
    //  if ((bln-awal) < 10) {
    //      this.enableNextYear=false;
    //  }
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.annualBudget) {
            this.filter[key] = filter.annualBudget[key];
            filtered=true;
        }
        if (filtered === true) {
          delete filter.annualBudget;
          this.$store.commit("filter", filter);
          this.process();
        } 

  },
methods:{
    onSelectLkuDept: async function (_selected) {
        this.filter.departemen = _selected.departkd.trim() + ' | ' + _selected.departemen.trim();
        this.filter.departid = _selected.departid;
        this.filter.departkd = _selected.departkd;
        this.lkuDeptShow=false;
    },
    saveFilter() {
      const keys = ['departkd', 'departemen', 'tahun', 'layout'];
      let filtered = false;
      const annualBudget={};
      for (const key in this.filter) {
          if (keys.indexOf(key) >= 0 && this.filter[key]) {
              filtered=true;
              annualBudget[key]=this.filter[key];
          }
      }
      if (filtered === true) {
        //   annualBudget.page=this.filter.page;
        //   annualBudget.limit=this.filter.limit;
        //   annualBudget.sortBy=this.filter.sortBy;
        //   annualBudget.sortDesc=this.filter.sortDesc;
          const filter = this.$store.state.filter;
          filter.annualBudget=annualBudget;
          this.$store.commit("filter", filter);
      } 
    },    

    add() {
        //   this.showAddConfirm = true;
          this.saveFilter();
          router.push({name :'budget.annualbudgetcopy'});
    },
    createBudget: async function() {
        if (this.invalidModel) {
            toastr.error('Please fill the form correctly.');
       } else {
           try {                
            this.isLoading=true;
            this.model.nextYear=this.nextYear;
            await budget_dept.createBudget(this.model);
            this.showAddConfirm = false;
            toastr.success('CREATE BUDGET completed successfully');
            this.refresh();               
           } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }               
           }
            this.isLoading=false;
       }
    },
    edit: function() {
        if (this.$v.filter.tahun.$error || this.$v.filter.departkd.$error) {
            toastr.warn('Please select YEAR and DEPARTMENT ');
        } else {
          this.saveFilter();
          router.push({name :'budget.annualbudgetfrm', params: { tahun: this.filter.tahun, departkd: this.filter.departkd}});
        }
    },    
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.rptLines= await budget_dept.view(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                this.reportUrl= await budget_dept.viewprint(this.filter);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await budget_dept.viewexport(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },

    close(){
      router.push("home");
    }
  }
};
</script>
